import React from "react";
import { Icon } from "@blueprintjs/core";
import PropTypes from "prop-types";
import "./Notifications.css";

export function SuccessPanel({
    children = <></>
}) {
    return (
        <div className="notification-panel success-panel">
            <div className="spacer-bottom-large">
                <Icon
                    icon="tick-circle"
                    size={100}
                />
            </div>
            <h2>Success!</h2>
            {children}
        </div>
    );
}

SuccessPanel.propTypes = {
    children: PropTypes.node
};